export default __webpack_public_path__ + "static/media/lesson_list.c7285223.jpg";